"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var helpers_1 = require("./helpers");

var N3 = require('n3');

var DataFactory = N3.DataFactory;
var namedNode = DataFactory.namedNode;

function isRelation(uri, model, prefixes) {
  var quad = model.getQuads(namedNode(uri), namedNode(prefixes.rdf + "type"), namedNode(prefixes.owl + "ObjectProperty"), null)[0];
  return !!quad;
}

exports.isRelation = isRelation;

function getRelation(uri, model, prefixes) {
  var domainQuad = model.getQuads(namedNode(uri), namedNode(prefixes.rdfs + "domain"), null, null)[0];
  var domainUri = domainQuad ? domainQuad.object.id : '';
  var rangeQuad = model.getQuads(namedNode(uri), namedNode(prefixes.rdfs + "range"), null, null)[0];
  var rangeUri = rangeQuad ? rangeQuad.object.id : '';
  return tslib_1.__assign(tslib_1.__assign({}, helpers_1.getURIData(uri, model, prefixes)), {
    uri: uri,
    domain: helpers_1.getElement(domainUri, model, prefixes),
    range: helpers_1.getElement(rangeUri, model, prefixes)
  });
}

exports.getRelation = getRelation;

function getRelations(model, prefixes) {
  var quads = model.getQuads(null, namedNode(prefixes.rdf + "type"), namedNode(prefixes.owl + "ObjectProperty"), null);
  var relations = quads.map(function (quad) {
    return getRelation(quad.subject.id, model, prefixes);
  });
  return relations.sort(function (c1, c2) {
    return c1.name > c2.name ? 1 : -1;
  });
}

exports.getRelations = getRelations;